<template>
  <v-row>
    <v-col>
      <mf-tabs-menu v-model="tab" :tabs="tabs" class="mb-4" />
      <consumed-cashback-metrics v-if="tab === 0" />
      <distributed-cashback-metrics v-else />
    </v-col>
  </v-row>
</template>

<script>
import ConsumedCashbackMetrics from '@/modules/mobile/cashback/views/components/ConsumedCashbackMetrics.vue'
import DistributedCashbackMetrics from '@/modules/mobile/cashback/views/components/DistributedCashbackMetrics.vue'

export default {
  name: 'CashbackMetricsTable',

  components: {
    ConsumedCashbackMetrics,
    DistributedCashbackMetrics,
  },

  data() {
    return {
      tab: 0,
    }
  },
  computed: {
    tabs() {
      return [
        {
          name: 'Consumo de cashback',
          haveLength: false,
        },
        {
          name: 'Distribuição de cashback',
          haveLength: false,
        },
      ]
    },
  },
}
</script>
